import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import NavigationProgressBar, {
  triggerProgress,
} from "../NavigationProgressBar/NavigationProgressBar";

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    triggerProgress();
  }, [pathname]);

  return (
    <>
      <NavigationProgressBar />
      {children || null}
    </>
  );
};

export default ScrollToTop;
